import React from 'react'
import MediaQueryWrapper from './MediaQueryWrapper'
import { minWidthMd } from 'shared/breakpoints'

const MobileView = (props) => {
  const newProps = { ...props, maxWidth: minWidthMd - 1 }

  return <MediaQueryWrapper {...newProps} />
}

export default MobileView
